var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLoadingSpinner = function SvgLoadingSpinner(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "48px",
    height: "48px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 1,
    transform: "scale(1.30501 1.30501)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.875s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.875s"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.21320343559643,71.21320343559643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.875,
    transform: "scale(1.36751 1.36751)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.75s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.75s"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.75,
    transform: "scale(1.43001 1.43001)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.625s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.625s"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.786796564403577,71.21320343559643)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.625,
    transform: "scale(1.49251 1.49251)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.5s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.5s"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,50.00000000000001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.5,
    transform: "scale(1.05501 1.05501)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.375s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.375s"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.78679656440357,28.786796564403577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.375,
    transform: "scale(1.11751 1.11751)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.25s"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.99999999999999,20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.25,
    transform: "scale(1.18001 1.18001)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.125s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "-0.125s"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.21320343559643,28.78679656440357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#095093",
    fillOpacity: 0.125,
    transform: "scale(1.24251 1.24251)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    values: "1.5 1.5;1 1",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;0",
    begin: "0s"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading-spinner.a7ae009a.svg";
export { ForwardRef as ReactComponent };